// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1UxmT","input-helper":"Checkbox_input-helper__1wrBP"};